import { Skeleton } from "antd";
import React from "react";

const BankedPublishSkeleton = () => {
  return (
    <>
      <div className="flex flex-col gap-4">
        <div>
          <Skeleton.Input
            style={{ width: 490, height: 50, borderRadius: 10 }}
            active={true}
            size="small"
          />
        </div>
        <div className="flex gap-3">
          <Skeleton.Input
            style={{ width: 150, height: 40, borderRadius: 10 }}
            active={true}
            size="small"
          />
          <Skeleton.Input
            style={{ width: 100, height: 40, borderRadius: 10 }}
            active={true}
            size="small"
          />
        </div>
      </div>
    </>
  );
};

export default BankedPublishSkeleton;
